import { Alert, AlertTitle } from '@material-ui/lab';
import { FormattedMessage } from 'react-intl';

export default function DataErrorFallback({ error,link,message, children }) {

    return (
        <>
            {error ?
                <Alert severity="warning">
                    <AlertTitle>
                       {message? message: <FormattedMessage defaultMessage="Huoltokatko. Yritäthän myöhemmin uudelleen!" />}
                    </AlertTitle>
                    {link && link}
                </Alert> :
                <>
                    {children}
                </>
            }
        </>
    );
}
